import React, { forwardRef, memo } from 'react'

const MicrophoneIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="58.8"
      height="58.8"
      viewBox="0 0 84 84"
      fill="none"
      {...props}>
      <circle cx="41.9496" cy="41.9496" r="41.9496" fill="#78BE20" />
      <path
        d="M57 47H27C26.3096 47 25.75 47.5596 25.75 48.25V52C25.75 52.6904 26.3096 53.25 27 53.25H57C57.6904 53.25 58.25 52.6904 58.25 52V48.25C58.25 47.5596 57.6904 47 57 47Z"
        stroke="white"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.25 46.9995V28.2495C38.25 27.918 38.3817 27.6 38.6161 27.3656C38.8505 27.1312 39.1685 26.9995 39.5 26.9995H44.5C44.8315 26.9995 45.1495 27.1312 45.3839 27.3656C45.6183 27.6 45.75 27.918 45.75 28.2495V46.9995"
        stroke="white"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.75 46.9999V43.2499C55.7509 40.2563 54.7748 37.3442 52.9699 34.9559C51.1651 32.5676 48.6301 30.8335 45.75 30.0171"
        stroke="white"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.25 46.9999V43.2499C28.2491 40.2563 29.2252 37.3442 31.0301 34.9559C32.8349 32.5676 35.3699 30.8335 38.25 30.0171"
        stroke="white"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

MicrophoneIcon.displayName = 'MicrophoneIcon'

export default memo(MicrophoneIcon)
